"use client"

import { useAppContext } from "@/lib/context/app-context"
import { useRouter } from "next/navigation"
import { useEffect } from "react"

export const dynamic = 'auto'
export const fetchCache = 'default-no-store'

export default function UserLayout({
  children,
}: {
  children: React.ReactNode
}) {
  let appContext = useAppContext()
  let router = useRouter()
  useEffect(() => {
    if (appContext.user) {
      let from = window.localStorage.getItem("login-redirect")
      window.localStorage.removeItem("login-redirect")
      if (from) {
        router.replace(from)
      }
    }
  }, [appContext])
  return <div>{children}</div>
}
